import { render } from "./LockingButton.vue?vue&type=template&id=4f4dc96a&scoped=true"
import script from "./LockingButton.vue?vue&type=script&lang=ts"
export * from "./LockingButton.vue?vue&type=script&lang=ts"

import "./LockingButton.vue?vue&type=style&index=0&id=4f4dc96a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f4dc96a"

export default script